import { AuthenticationRoleResponse, TenantUser, TenantInfoRequest, UserDeviceInfo, SecurityRoleTiny } from '@jms/model';
import { Action } from '@ngrx/store';

export interface ApplicationSettings {
  applicationName: string;
  applicationDescription: string;
  logo: string;
  banner: string;
}

export interface ApplicationAction extends Action {
  payload: any;
}

export enum ApplicationActionName {
  ToggleNav = '[Application] Toggle Nav',
  Login = '[Application] Login',
  LoggedIn = '[Application] Logged In',
  LoginError = '[Application] Login Error',
  Logout = '[Application] Logout',
  RouterNavigating = '[Application] Router Navigating',
  RouterNavigated = '[Application] Router Navigated',
  LoginAuthorise = '[Application] Login Authorise',
  LoginAuthorised = '[Application] Login Authorised',
  MapSocialUser = '[Application] Map Social User',
  RequireMapUser = '[Application] Require Map User',
  GetTenantInfo = '[Application] Get Tenant Info',
  ActionSuccess = '[Application] Action Success',
  SetDeviceInfo = '[Application] Set Device Info',
  SetGeneralSetting = '[Application] Set General Setting'
}

export interface SocialUser {
  idToken: string;
  accessToken: string;
  image: string;
  profile: any;
  provider: string;
  sub: string;
}


export interface ApplicationState {
  navExpanded: boolean;
  token: string;
  role: SecurityRoleTiny;
  user: TenantUser;
  socialUser: SocialUser;
  settings: ApplicationSettings;
  login: AuthenticationRoleResponse;
  route: any;
  returnUrl: string;
  domain: string;
  info: TenantInfoRequest;
  device: UserDeviceInfo;
}
